import React, { memo } from "react";

import { toAbsoluteUrl } from "../../../../_metronic/helpers";

interface IProps {
  errorMessage: string;
}

const ErrorView: React.FC<IProps> = memo(({ errorMessage }) => {
  return (
    <div className="azs-main-wrapper already-activated">
      <div className="azs-container activate-component h-auto">
        <div className="h-100 activate-component__content">
          <div className="activate-component__logo">
            <img
              alt="Logo"
              src={toAbsoluteUrl("/media/logos/tc-logo-light.svg")}
              className="theme-light-show loaderimg"
            />
            <img
              alt="Logo"
              src={toAbsoluteUrl("/media/logos/tc-logo-dark.svg")}
              className="theme-dark-show loaderimg"
            />
          </div>
          <div className="activate-component__header">
            We&#39;re sorry, something went wrong.
          </div>
          <div className="activate-component__subheader">{errorMessage}</div>
        </div>
      </div>
    </div>
  );
});

export { ErrorView };
